import { icons } from 'common'
import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/games_panel.css */
  .pd_switch_wrapper {
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 0 20px;
  }
  .pd_switch_wrapper .pd_bg {
    position: relative;
    width: 100%;
    background-color: hsla(126, 100%, 38%, 0.2);
    color: #fff;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: background-color 0.1s;
    border-radius: 10px;
  }
  .pd_switch_wrapper .pd_content {
    display: flex;
    flex-direction: column;
    text-align: center;
    width: 100%;
    transform: translateY(5%);
  }
  .pd_switch_wrapper label,
  .pd_switch_wrapper .pd_toggle {
    height: 35px;
    border-radius: 10px;
  }
  .pd_switch_wrapper label {
    width: 100%;
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    position: relative;
    padding: 0;
    cursor: pointer;
  }
  .pd_switch_wrapper .pd_toggle {
    position: absolute;
    width: 50%;
    background-color: hsla(126, 100%, 27%, 1);
    transition: transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    top: -1px;
  }
  .pd_switch_wrapper .names {
    width: 100%;
    padding: 0 18%;
    transform: translateY(-50%);
    top: calc(50% - 2px);
    position: absolute;
    display: flex;
    justify-content: space-between;
    user-select: none;
  }
  .pd_switch_wrapper .names p {
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.75rem;
    text-transform: uppercase;
  }
  .pd_switch_wrapper .price_direction_icon {
    mask-size: auto 12px;
    width: 12px;
    height: 12px;
    position: relative;
    top: 0;
  }
  .pd_switch_wrapper .price_direction_icon.up,
  .pd_switch_wrapper .price_direction_icon.down {
    background: #fff;
  }
  .pd_switch_wrapper p.down {
    opacity: 0.5;
    font-weight: 300;
  }
  .pd_switch_wrapper [type='checkbox'] {
    display: none;
  }
  .pd_switch_wrapper [type='checkbox']:checked + .price_direction_switch .pd_toggle {
    transform: translateX(100%);
    background-color: hsla(340, 88%, 46%, 1);
  }
  .pd_switch_wrapper [type='checkbox']:checked + .price_direction_switch .down {
    opacity: 1;
    font-weight: 700;
  }
  .pd_switch_wrapper [type='checkbox']:checked + .price_direction_switch .up {
    opacity: 0.5;
    font-weight: 300;
  }
  .pd_switch_wrapper [type='checkbox']:checked + .price_direction_switch .pd_bg {
    background-color: hsla(340, 88%, 46%, 0.2);
    color: #fff;
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/gameplay.css */
  .price_direction_icon {
    mask: url(${icons.bid_direction_icon}) center center / auto 18px no-repeat;
    width: 18px;
    height: 18px;
    margin: 0 3px 0 0;
  }
  .price_direction_icon.up {
    background: hsl(126, 100%, 38%);
    transform: rotate(180deg);
  }
  .price_direction_icon.down {
    background: hsl(340, 88%, 46%);
    transform: rotate(0deg);
  }
  .row.subtitle {
    font-weight: 600;
    font-size: 0.75rem;
    margin: 0 0 8px 0;
    text-transform: uppercase;
  }
  .subtitle {
    font-weight: 600;
    font-size: 0.75rem;
    white-space: nowrap;
    text-transform: uppercase;
    display: flex;
    align-items: center;
  }
  .subtitle {
    align-items: flex-start;
    justify-content: flex-start;
  }
`

const developerCSS = css``

export const UpDownToggleCSS = styled.div`
  width: 100%;
  ${designerCSS}
  ${developerCSS}
`
